export default Object.freeze({
  Company: 'company',
  Environment: 'environment',
});
